import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { deleteAddons, getAddons } from '../../../CommonURL';
import { getDataWithToken, postDataWithToken } from '../../../Utils/restUtils';
import { Add } from '../../../Constant';
import SearchList from '../../../CommonElements/Search';
import { AddonsColumns } from '../../../Data/MockTable/TableHeaderList';
import Transparentspinner from '../../Common/loader/Transparentspinner'

const AddonsList = () => {
    const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: '10px' };
    const [addonsList, setAddonsList] = useState([])
    const [addonsData, setAddonsData] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    useEffect(() => {
        getAddonsData(); // do not put await here
    }, [searchKeyword]);

    const filteredItems = addonsData.filter(
        (item) => item.name && item.name.toLowerCase().includes(searchKeyword.toLowerCase()) ||
            item.industry_name && item.industry_name.toLowerCase().includes(searchKeyword.toLowerCase()) ||
            item.description && item.description.toLowerCase().includes(searchKeyword.toLowerCase()) ||
            item.price && item.price.toLowerCase().includes(searchKeyword.toLowerCase())
    );

    const updateSearchKeyword = (keyword) => {
        setSearchKeyword(keyword);
    };

    const redirectToEditForm = (data) => {
        const editFormURL = `${process.env.PUBLIC_URL}/master-records/addons-edit?${data.id}`;
        navigate(editFormURL);
    };

    const deleteAddonsList = (userId) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this imaginary file!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'cancel',
            reverseButtons: true
        }).then(async (result) => {
            setLoading(true)
            if (result.value) {
                const deleteRes = { add_on_id: userId }
                const industryDelete = await postDataWithToken(deleteAddons, deleteRes);
                if (industryDelete.data.message === 'success') {
                    SweetAlert.fire(
                        'Deleted!',
                        'Your file has been deleted.',
                        'success'
                    );
                    addonsData();
                } else {
                    setLoading(false)
                    navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
                }
            } else {

            }
            setLoading(false)
        });
    };

    const getAddonsData = async () => {
        setLoading(true)
        let data = await getDataWithToken(getAddons);
        setResetPaginationToggle(!resetPaginationToggle);
        setAddonsData(data.data)
        if (searchKeyword === '') {
            setAddonsList(data.data.map((e, index) => {
                return {
                    Si: index + 1,
                    Name: <span>{e.name}</span>,
                    Industry: e.industry_name,
                    Description: e.description,
                    Price: e.price,
                    Mrp: e.mrp,
                    action:
                        <div>
                            <span>
                                <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToEditForm(e) }}>Edit </Btn>
                            </span>
                            <span>
                                <Btn attrBtn={{ style: style2, className: 'me-2', color: 'danger btn-xs', type: 'button', onClick: () => { deleteAddonsList(e.id) } }}>Delete</Btn>
                            </span>
                        </div >
                }
            }))
        } else {
            setAddonsList(filteredItems.map((e, index) => {
                return {
                    Si: index + 1,
                    Name: <span>{e.name}</span>,
                    Industry: e.industry_name,
                    Description: e.description,
                    Price: e.price,
                    Mrp: e.mrp,
                    action:
                        <div>
                            <span>
                                <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToEditForm(e) }}>Edit </Btn>
                            </span>
                            <span>
                                <Btn attrBtn={{ style: style2, className: 'me-2', color: 'danger btn-xs', type: 'button', onClick: () => { deleteAddonsList(e.id) } }}>Delete</Btn>
                            </span>
                        </div >
                }
            }))
        }
        setLoading(false)
    };
    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle='User' parent="Administration" title="Addons" />
            <Card>
                <CardHeader>
                    <H3>Add ons</H3>
                </CardHeader>
                <div style={{ paddingLeft: '22px', marginRight: '22px', marginBottom: '-20px' }}>
                    <div style={{ float: 'left' }}>
                        <SearchList updateSearchKeyword={updateSearchKeyword} />
                    </div>
                    <div style={{ float: 'right' }}>
                        <Link to={`${process.env.PUBLIC_URL}/master-records/addons-add`} className="btn btn-primary">{Add}</Link>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>
                <CardBody>
                    <div className="order-history table-responsive">
                        <DataTable
                            data={addonsList}
                            columns={AddonsColumns}
                            pagination
                            style={{ border: '1px solid' }}
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default AddonsList;